import { FC } from 'react';

import { Wrapper } from './ShowUp.styles';

export const ShowUp: FC<any> = ({ children, untilTo = '' }) => <Wrapper untilTo={untilTo}>{children}</Wrapper>;
